import styled from "styled-components";

const PageText = styled.h1`
  margin-bottom: 2rem;
  color: ${props => props.theme.black};
  span {
    font-size: inherit;
    text-transform: capitalize;
  }
`;

export default PageText;
